import { useState } from 'react';
import { t } from '../i18n/index.ts';
import { money, qty as fmtQty } from '../lib/format.ts';
import { useImageUrl, type PriceNow } from '../lib/menu.ts';
import type { CatalogProduct } from '../lib/types.ts';
import { Icon } from './Icon.tsx';
import { StatusBadge } from './ui.tsx';

/**
 * One item on the order screen: its photo when it has one, its name and its price now. During
 * a price time (happy hour) the normal price is struck through and the deal is named.
 */
export function ProductTile({
  product: p,
  tone,
  price,
  hint,
  count,
  onTap,
}: {
  product: CatalogProduct;
  tone: string;
  price: PriceNow;
  hint: string | null;
  count: number;
  onTap: () => void;
}) {
  const imageUrl = useImageUrl();
  const [broken, setBroken] = useState(false);
  const src = broken ? null : imageUrl(p);
  const deal = price.rule && price.price < p.price;
  return (
    <button
      className={`product-tile tone-${tone}${src ? ' has-photo' : ''}`}
      disabled={!p.available}
      onClick={onTap}
    >
      {src ? <img className="product-photo" src={src} alt="" loading="lazy" decoding="async" onError={() => setBroken(true)} /> : null}
      <span className="product-name">{p.name}</span>
      {deal ? (
        <span className="product-deal">
          <Icon name="clock" size={12} /> {price.rule}
        </span>
      ) : null}
      <span className="product-foot">
        <span className="product-price">
          {deal ? <s className="product-was">{money(p.price)}</s> : null}
          {money(price.price)}
        </span>
        {!p.available ? <StatusBadge tone="danger" icon="x" label={t('product.sold_out')} /> : hint ? <span className="product-hint">{hint}</span> : null}
      </span>
      {count > 0 ? (
        <span className="product-count" aria-label={t('product.on_bill', { n: count })}>
          {fmtQty(count)}
        </span>
      ) : null}
    </button>
  );
}
